"use strict";

require("../../style/index.less");

require("./index.less");

require("../../input/style");

require("../../time-picker/style");

require("../../tag/style");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/date-picker/style/index.js
// module id = 144
// module chunks = 1